module.exports = __webpack_public_path__ + "static/media/Restart.a51d02ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Customization/components/Customize/assets/Restart.png
// module id = 701
// module chunks = 0